export class SheetBuilderRule {
    id: number;
    prefix: string;
    prefix_not: string;
    cpm_greater_than: number;
    cpm_less_than: number;
    cpc_greater_than: number;
    cpc_less_than: number;
}
